import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { AnalyticsDevFlagsEffects } from './lib/analytics-dev-flags.effects';
import { AnalyticsDevFlagsHttpClient } from './lib/analytics-dev-flags.http';
import {
  AnalyticsDevFlagsNamespace,
  AnalyticsDevFlagsReducer,
} from './lib/analytics-dev-flags.store';

export * from './lib/analytics-dev-flags.store';
export * from './lib/analytics-dev-flags.http';

export const analyticsDevFlagsData = [
  AnalyticsDevFlagsHttpClient,
  provideState(AnalyticsDevFlagsNamespace, AnalyticsDevFlagsReducer),
  provideEffects([AnalyticsDevFlagsEffects]),
];
